import { render } from "./InstancesTemplate.vue?vue&type=template&id=5eb01957&scoped=true&ts=true"
import script from "./InstancesTemplate.vue?vue&type=script&lang=ts"
export * from "./InstancesTemplate.vue?vue&type=script&lang=ts"

import "./InstancesTemplate.vue?vue&type=style&index=0&id=5eb01957&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb01957"]])

export default __exports__